 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Agreement":"Agreement","BBRTConfirm":"BBRTConfirm","Complete~Face~G3-report~HealthNotification~Home~InfoConfirm~Insure~Introduce~MyOrder~MyReport~MyTrai~2e402feb":"Complete~Face~G3-report~HealthNotification~Home~InfoConfirm~Insure~Introduce~MyOrder~MyReport~MyTrai~2e402feb","Complete":"Complete","Face~G3-report~Home~Insure~Introduce~MyTrain~Privacy~Product~Question~employeeHandbook~productFactory":"Face~G3-report~Home~Insure~Introduce~MyTrain~Privacy~Product~Question~employeeHandbook~productFactory","Face":"Face","G3-report~SCSReport":"G3-report~SCSReport","G3-report":"G3-report","Home":"Home","InfoConfirm~Insure":"InfoConfirm~Insure","Insure":"Insure","Introduce":"Introduce","MyTrain":"MyTrain","Privacy~SCSReport":"Privacy~SCSReport","Privacy":"Privacy","Product":"Product","Question~transitPage":"Question~transitPage","Question":"Question","employeeHandbook":"employeeHandbook","productFactory":"productFactory","SCSReport":"SCSReport","HealthNotification":"HealthNotification","InfoConfirm":"InfoConfirm","MyOrder":"MyOrder","MyReport":"MyReport","OrderDetails":"OrderDetails","transitPage":"transitPage","Success":"Success","agentLogin":"agentLogin","agentMy":"agentMy","wechatH5":"wechatH5","Confirm":"Confirm","EnsureDetails":"EnsureDetails","Error":"Error","Game":"Game","GoBack":"GoBack","ProductConfirm":"ProductConfirm","agentOrdeDetails":"agentOrdeDetails","agentWithdrawalDetails":"agentWithdrawalDetails","cantactKefu":"cantactKefu","personalLink":"personalLink","productUse":"productUse","scanCode":"scanCode","userBehaPath":"userBehaPath","userProfile":"userProfile","userReport":"userReport","userReportList":"userReportList","userSource":"userSource","userTags":"userTags"}[chunkId]||chunkId) + "." + {"Agreement":"319a975c","BBRTConfirm":"dd7b001b","Complete~Face~G3-report~HealthNotification~Home~InfoConfirm~Insure~Introduce~MyOrder~MyReport~MyTrai~2e402feb":"e06b19d9","Complete":"a263bc7d","Face~G3-report~Home~Insure~Introduce~MyTrain~Privacy~Product~Question~employeeHandbook~productFactory":"53ee3fd0","Face":"b783c216","G3-report~SCSReport":"fe3b4b29","G3-report":"8405c5a3","Home":"6a2904cf","InfoConfirm~Insure":"1e221845","Insure":"61c1b14f","Introduce":"848dbeb1","MyTrain":"d3d2c983","Privacy~SCSReport":"35182d4d","Privacy":"4c7db51b","Product":"99fe8099","Question~transitPage":"8a5ca5f3","Question":"6f3bc027","employeeHandbook":"5066e3c6","productFactory":"d2feec72","SCSReport":"3ac97dc8","HealthNotification":"73e1b4e1","InfoConfirm":"fe7922bf","MyOrder":"f20e09b9","MyReport":"6ea91c54","OrderDetails":"424ce5fa","transitPage":"f9084955","Success":"0b9b9390","agentLogin":"b46316ed","agentMy":"9bd3d25c","wechatH5":"b7d30cb1","Confirm":"fab62ae6","EnsureDetails":"9df74b3b","Error":"7b0df450","Game":"436c4621","GoBack":"4347da65","ProductConfirm":"e969be59","agentOrdeDetails":"b596cedf","agentWithdrawalDetails":"7388724e","cantactKefu":"dc165fe9","chunk-2d0b19b6":"d085f4c8","personalLink":"f23390e4","productUse":"38ccf239","scanCode":"54a97189","userBehaPath":"2a07852a","userProfile":"37e32730","userReport":"7f02ae28","userReportList":"62a73b8c","userSource":"c810c2c9","userTags":"493e5141"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Agreement":1,"Complete":1,"Face":1,"G3-report":1,"Home":1,"InfoConfirm~Insure":1,"Insure":1,"Introduce":1,"MyTrain":1,"Privacy":1,"Product":1,"Question":1,"employeeHandbook":1,"productFactory":1,"SCSReport":1,"HealthNotification":1,"InfoConfirm":1,"MyOrder":1,"MyReport":1,"OrderDetails":1,"transitPage":1,"Success":1,"agentLogin":1,"agentMy":1,"Confirm":1,"EnsureDetails":1,"Error":1,"Game":1,"GoBack":1,"ProductConfirm":1,"agentOrdeDetails":1,"agentWithdrawalDetails":1,"cantactKefu":1,"personalLink":1,"productUse":1,"scanCode":1,"userBehaPath":1,"userProfile":1,"userReport":1,"userReportList":1,"userSource":1,"userTags":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Agreement":"Agreement","BBRTConfirm":"BBRTConfirm","Complete~Face~G3-report~HealthNotification~Home~InfoConfirm~Insure~Introduce~MyOrder~MyReport~MyTrai~2e402feb":"Complete~Face~G3-report~HealthNotification~Home~InfoConfirm~Insure~Introduce~MyOrder~MyReport~MyTrai~2e402feb","Complete":"Complete","Face~G3-report~Home~Insure~Introduce~MyTrain~Privacy~Product~Question~employeeHandbook~productFactory":"Face~G3-report~Home~Insure~Introduce~MyTrain~Privacy~Product~Question~employeeHandbook~productFactory","Face":"Face","G3-report~SCSReport":"G3-report~SCSReport","G3-report":"G3-report","Home":"Home","InfoConfirm~Insure":"InfoConfirm~Insure","Insure":"Insure","Introduce":"Introduce","MyTrain":"MyTrain","Privacy~SCSReport":"Privacy~SCSReport","Privacy":"Privacy","Product":"Product","Question~transitPage":"Question~transitPage","Question":"Question","employeeHandbook":"employeeHandbook","productFactory":"productFactory","SCSReport":"SCSReport","HealthNotification":"HealthNotification","InfoConfirm":"InfoConfirm","MyOrder":"MyOrder","MyReport":"MyReport","OrderDetails":"OrderDetails","transitPage":"transitPage","Success":"Success","agentLogin":"agentLogin","agentMy":"agentMy","wechatH5":"wechatH5","Confirm":"Confirm","EnsureDetails":"EnsureDetails","Error":"Error","Game":"Game","GoBack":"GoBack","ProductConfirm":"ProductConfirm","agentOrdeDetails":"agentOrdeDetails","agentWithdrawalDetails":"agentWithdrawalDetails","cantactKefu":"cantactKefu","personalLink":"personalLink","productUse":"productUse","scanCode":"scanCode","userBehaPath":"userBehaPath","userProfile":"userProfile","userReport":"userReport","userReportList":"userReportList","userSource":"userSource","userTags":"userTags"}[chunkId]||chunkId) + "." + {"Agreement":"c6fa6a6b","BBRTConfirm":"31d6cfe0","Complete~Face~G3-report~HealthNotification~Home~InfoConfirm~Insure~Introduce~MyOrder~MyReport~MyTrai~2e402feb":"31d6cfe0","Complete":"338696a5","Face~G3-report~Home~Insure~Introduce~MyTrain~Privacy~Product~Question~employeeHandbook~productFactory":"31d6cfe0","Face":"a058be58","G3-report~SCSReport":"31d6cfe0","G3-report":"78f037ed","Home":"70f9bffd","InfoConfirm~Insure":"da60ee1b","Insure":"dd82303b","Introduce":"05a5e53b","MyTrain":"c3553cc9","Privacy~SCSReport":"31d6cfe0","Privacy":"3effe66b","Product":"741775f6","Question~transitPage":"31d6cfe0","Question":"60592041","employeeHandbook":"5e639488","productFactory":"38d9393f","SCSReport":"91c647e2","HealthNotification":"75023107","InfoConfirm":"8b6b1208","MyOrder":"592d2a5a","MyReport":"c51c0fbe","OrderDetails":"ebb08fb3","transitPage":"4f85be6a","Success":"817fff73","agentLogin":"d0228492","agentMy":"f55b3131","wechatH5":"31d6cfe0","Confirm":"f705eed4","EnsureDetails":"26155b4a","Error":"c8f48240","Game":"734085c3","GoBack":"5c2fa7a0","ProductConfirm":"7d192c93","agentOrdeDetails":"297138b6","agentWithdrawalDetails":"3db80f97","cantactKefu":"cd6ca2ea","chunk-2d0b19b6":"31d6cfe0","personalLink":"e7974a8d","productUse":"1f527940","scanCode":"01c860f9","userBehaPath":"0ea80f27","userProfile":"07cc5cc9","userReport":"2ba0cacb","userReportList":"1c8f57b2","userSource":"bb29981e","userTags":"b08aa3cc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/bst/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
